import { render, staticRenderFns } from "./FrecuenciaForm.vue?vue&type=template&id=0f12d1aa"
import script from "./FrecuenciaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FrecuenciaForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports